<template>
  <div>
    <h2>这是<em>代码生成</em>画面！</h2>
  </div>
</template>

<script>

  export default {
    data() {
      return {

      }
    },
    methods: {
    },
    mounted() {
    }

  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/Sys/Generator.vue